import { LastMessagesResponse } from '../../types/chat';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

export async function lastMessages(conversationId?: number): Promise<LastMessagesResponse> {
  try {
    const accessToken = localStorage.getItem('accessToken');
    
    // Build URL with optional conversation_id parameter
    let url = `${API_BASE_URL}/chat/last_messages/`;
    if (conversationId) {
      url += `?conversation_id=${conversationId}`;
    }
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch last messages');
    }
    
    return response.json();
  } catch (error) {
    console.error('Error fetching last messages:', error);
    return {
      latest_conversation_id: 0,
      latest_conversation_language: 'en-US',
      serialized_messages: []
    };
  }
}
